import React from "react";
import TableWiseView from "./TableWiseView";
import { useKitchenNow } from "./TimedOrderCard";
import { buildTableWorkload } from "../tableWorkload";

export default function TableWorkloadView({ catalogue, jobs, ...props }) {
  const now = useKitchenNow();
  return <TableWiseView {...props} tables={buildTableWorkload(catalogue, jobs, now)} />;
}
